import { useState, useEffect } from 'react';
export function useLocalStorage(key, initialValue) {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      if (item === null || item === 'null' || item === '') {
        return initialValue;
      }
      return JSON.parse(item);
    } catch (error) {
      console.log(error);
      return initialValue;
    }
  });
  useEffect(() => {
    try {
      if (storedValue === null || storedValue === undefined) {
        window.localStorage.removeItem(key);
      } else {
        window.localStorage.setItem(key, JSON.stringify(storedValue));
      }
    } catch (error) {
      console.log(error);
    }
  }, [key, storedValue]);
  return [storedValue, setStoredValue];
}
